<template>
  <!-- 综合运行监控 -->
  <div class="app-container">
    <div class="title-container">
      <span class="runDays"> 安全运行 {{ monitorData.runDays }} 天</span>
      {{ monitorData.iotPlatformName }}
      <span class="time">{{ timeStr }}</span>
    </div>
    <div class="content-container clearfix">
      <div class="nums">
        <div class="lixian" @click="showCameraDlg('2')">
          <div class="name">离线设备</div>
          <div class="num-unit">
            <span class="num">{{
              deviceData.countOfflineNum + deviceData.cameraOfflineNum || ""
            }}</span>
            <span class="unit">个</span>
          </div>
        </div>
        <div class="zaixian" @click="showCameraDlg('0')">
          <div class="name">在线设备</div>
          <div class="num-unit">
            <span class="num">{{
              deviceData.countOnlineNum + deviceData.cameraOnlineNum || ""
            }}</span>
            <span class="unit">个</span>
          </div>
        </div>
        <div class="zongshu" @click="showCameraDlg('999')">
          <div class="name">总设备数</div>
          <div class="num-unit">
            <span class="num">{{
              deviceData.countEquipNum + deviceData.countCameraNum || ""
            }}</span>
            <span class="unit">个</span>
          </div>
        </div>
        <div class="yichang" @click="pageTo(3)">
          <div class="name">处理中</div>
          <div class="num-unit">
            <span class="num">{{ deviceData.countAlarmNum }}</span>
            <span class="unit">个</span>
          </div>
        </div>
        <div class="daichuli" @click="pageTo(4)">
          <div class="name">待处理</div>
          <div class="num-unit">
            <span class="num">{{ deviceData.waitForAlarmNum }}</span>
            <span class="unit">个</span>
          </div>
        </div>
      </div>
      <div class="left-container">
        <div class="top-container clearfix">
          <div class="left-container">
            <div class="title" style="font-weight: bolder;">
              <span>设备运行状态</span>
            </div>
            <div class="state-container clearfix">
              <div
                class="state-item clearfix"
                @mouseenter="mouseEnter(index)"
                :class="{ error: item.status == 1, active: index == activeIdx }"
                v-for="(item, index) in monitorData.equipRoomItems"
                @click="viewItem(item.id)"
                :key="item.id"
              >
                <div class="zhegai-border"></div>
                <div class="zhegai-border-bottom"></div>
                <div class="fugai-border-top"></div>
                <div class="border-radius-bottom"></div>
                <div class="equip-info">
                  <div class="equip-name">{{ item.name }}</div>
                  <div class="equip-state">
                    <div class="equip-state-quanbu">
                      <div style="font-weight: 500">全部</div>
                      <div class="count">{{ item.countEquipNum }}</div>
                    </div>
                    <div class="equip-state-zaixian">
                      <div style="font-weight: 500">在线</div>
                      <div class="count">{{ item.countOnlineNum }}</div>
                    </div>
                    <div class="equip-state-lixian">
                      <div style="font-weight: 500">离线</div>
                      <div class="count">{{ item.countOfflineNum }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-container">
            <div class="statistical-container">
              <div class="bottom-container clearfix">
                <el-carousel
                  v-if="showDataState"
                  ref="carousel"
                  :interval="100000000"
                  trigger="click"
                  indicator-position="none"
                  @change="carouselChange"
                >
                  <el-carousel-item
                    v-for="item in monitorData.equipRoomItems"
                    :key="item.equipId"
                  >
                    <div class="title clearfix">
                      <span class="fl">
                        <div class="equipRoomItems-name">
                          <div class="name">{{ item.name }}</div>
                        </div>
                      </span>
                      <span class="fr">
                        <span
                          style="margin-right: 20px; font-size: 14px; color: #fff"
                          >在线：{{ item.countOnlineNum }}</span
                        >
                        <span style="font-size: 14px; color: #d3e2fd"
                          >离线：{{ item.countOfflineNum }}</span
                        >
                      </span>
                    </div>
                    <div style="padding: 0 10px 0 20px">
                      <div
                        class="detail clearfix no-scrollbar"
                        :class="item.equipItems.length > 5 ? 'row2' : ''"
                        style="max-height: 126px; overflow-y: auto"
                      >
                        <span
                          v-for="(item1, index1) in item.equipItems"
                          :key="index1"
                          :title="item1.name"
                        >
                          <div>{{ item1.name }}</div>
                          <div :class="item1.status == 1 ? 'error' : ''">
                            {{ item1.status == 1 ? "异常" : "正常" }}
                          </div>
                        </span>
                      </div>
                      <div class="title">
                        <div class="equipRoomItems-name-huanjing">
                          <div class="name">环境</div>
                        </div>
                      </div>
                      <div class="detail clearfix" style="margin-bottom: 10px">
                        <span
                          :class="{ 'filter-gray': item.esTemperature == -1 }"
                        >
                          <div>
                            {{
                              item.esTemperature == -1
                                ? "无"
                                : (item.esTemperature || 0) + "℃"
                            }}
                          </div>
                          <div>温度</div>
                        </span>
                        <span :class="{ 'filter-gray': item.esHumidity == -1 }">
                          <div>
                            {{
                              item.esHumidity == -1
                                ? "无"
                                : (item.esHumidity || 0) + "%RH"
                            }}
                          </div>
                          <div>湿度</div>
                        </span>
                        <span
                          :class="{
                            'filter-gray': item.esIntrusionStatus == -1
                          }"
                        >
                          <div :class="item.esWaterStatus == 1 ? 'error' : ''">
                            {{
                              item.esWaterStatus == 1
                                ? "异常"
                                : item.esWaterStatus == -1
                                ? "无"
                                : "正常"
                            }}
                          </div>
                          <div>水浸</div>
                        </span>
                        <span
                          :class="{
                            'filter-gray': item.esIntrusionStatus == -1
                          }"
                        >
                          <div :class="item.esSmokeStatus == 1 ? 'error' : ''">
                            {{
                              item.esSmokeStatus == 1
                                ? "异常"
                                : item.esSmokeStatus == -1
                                ? "无"
                                : "正常"
                            }}
                          </div>
                          <div>烟雾</div>
                        </span>
                        <span
                          :class="{
                            'filter-gray': item.esIntrusionStatus == -1
                          }"
                        >
                          <div
                            :class="item.esIntrusionStatus == 1 ? 'error' : ''"
                          >
                            {{
                              item.esIntrusionStatus == 1
                                ? "异常"
                                : item.esIntrusionStatus == -1
                                ? "无"
                                : "正常"
                            }}
                          </div>
                          <div>红外</div>
                        </span>
                      </div>
                      <div class="title">
                        <div class="equipRoomItems-name-24hours">
                          <div class="name">24h内报警</div>
                        </div>
                      </div>
                      <div :class="item.recentAlarm ? 'fred red' : 'fred blue'">
                        <div class="fred-name" v-if="item.recentAlarm">
                          {{ item.recentAlarm.content }}
                        </div>
                        <div class="fred-content" v-if="item.recentAlarm">
                          {{ item.recentAlarm.alertName
                          }}{{ item.recentAlarm.alarmValue
                          }}{{ item.recentAlarm.unit }}
                          <span>{{ item.recentAlarm.createTime }}</span>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="bottom-container clearfix">
          <div class="bottom-left clearfix">
            <div class="title" style="font-weight: bolder;">
              <span>报警统计</span>
            </div>
            <div class="pie-container" id="pie-chart0"></div>
          </div>
          <div class="bottom-center clearfix">
            <div class="title" style="font-weight: bolder;">
              <span>异常统计</span>
            </div>
            <div class="echart-container" id="echart-panel0"></div>
          </div>
        </div>
      </div>
      <div class="right-container0">
        <div class="top-container">
          <div style="height: 100%">
            <div class="top-title" style="font-weight: bolder;">
              <div>设备运行参数</div>
            </div>
            <div class="state-container clearfix" ref="configTable">
              <div
                class="state-item clearfix"
                v-for="(item, index) in monitorData.equipRunParams"
                :key="item.id"
              >
                <div class="state-item-title">
                  <div class="state-item-name">设备间</div>
                  <div class="state-item-equipRoomName">
                    {{ item.equipRoomName }}
                  </div>
                </div>
                <div class="state-item-title">
                  <div class="state-item-name">名称</div>
                  <div class="state-item-equipRoomName">{{ item.name }}</div>
                </div>
                <div class="state-item-bg">
                  <div class="state-bg-item">
                    <div>{{ item.status == 1 ? "异常" : "正常" }}</div>
                    <div>{{ item.currentValue }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-container">
          <div style="height: 100%">
            <div class="title" style="font-weight: bolder;">
              <span>报警提示</span>
            </div>
            <div class="table-container2">
              <el-table
                :data="alarmsData.abnormalAlarms"
                ref="alarmsTable"
                height="100%"
              >
                <el-table-column
                  label="设备间"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span class="f12" style="color: #c8d7e8">{{
                      scope.row.equipName
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="名称"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span class="f12" style="color: #c8d7e8">{{
                      scope.row.nodeName
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="类型"
                  align="center"
                  width="85"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span class="f12" style="color: #ffc600">{{
                      scope.row.alertName
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="时间" align="center" width="140">
                  <template slot-scope="scope">
                    <span class="f12" style="color: #c8d7e8">{{
                      scope.row.createTime
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CameraDlg
      ref="cameraDlg"
      :dlgData0="dlgCameraState"
      :dlgQuery="dlgCameraQuery"
    />
  </div>
</template>

<script>
import CameraDlg from "../electricalFireMonitoring/components/cameraDlg";
import { mapGetters } from "vuex";
import Cookie from "js-cookie";
import { postAction, getAction } from "@/api";
import * as echarts from "echarts";
import "echarts-gl";
import * as utils from "@/utils";
import {
  integratedOperationMonitoring,
  integratedAbnormalAlarms,
  integratedATj, // 异常统计
  integratedABj // 异常趋势分析
} from "@/api/basicManSystem/comprehenOperateMonitor.js";
let pieChart;
export default {
  components: { CameraDlg },
  data() {
    return {
      dlgCameraQuery: {},
      dlgCameraState: false,
      userInfo: JSON.parse(window.localStorage.userInfo),

      timeStr: utils.getTotime() + `(星期${utils.getWeek()})`,

      monitorData: {},
      deviceData: {},
      alarmsData: {},

      exceptionData: {},

      echartPanel: null, // echart面板

      timer: null,
      pageInterval: null,
      tableTimer: null,

      deviceList: [],

      activeIdx: 0,

      itemHeight: 108,
      intervalId: null,
      configTable: null,
      scrollPosition: 0,
      pageInterval: null, //定时器
      pieChartData: [] //饼图数据
    };
  },

  created() {
    this.getMonitor();
    this.getEquipNodeStatistics();
    this.getAlarms();
    this.getExceptionATj();
    this.getPieChart();
    this.$nextTick(() => {
      this.changeTime();
      this.scrollTable();
    });
  },

  mounted() {
    this.changeTime();
    this.refreshPage();
    if (this.pageInterval) {
      clearInterval(this.pageInterval);
    }
    this.pageInterval = setInterval(() => {
      this.showDataState = false;
      this.refreshPage();
    }, 60 * 1000);

    window.addEventListener("resize", e => {
      setTimeout(() => {
        if (!utils.isNull(this.echartPanel)) {
          this.echartPanel.resize();
        }
      }, 400);
    });
    window.addEventListener("resize", e => {
      setTimeout(() => {
        if (!utils.isNull(pieChart)) {
          pieChart.resize();
        }
      }, 400);
    });
  },

  beforeDestroy() {
    if (this.pageInterval) {
      clearInterval(this.pageInterval);
      this.pageInterval = null;
    }
    if (!utils.isNull(this.timer)) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (!utils.isNull(this.pageInterval)) {
      clearInterval(this.pageInterval);
      this.pageInterval = null;
    }
    if (!utils.isNull(this.tableTimer)) {
      clearInterval(this.tableTimer);
      this.tableTimer = null;
    }
    if (!utils.isNull(this.intervalId)) {
      this.scrollPosition = 0;
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },

  methods: {
    refreshPage() {
      this.getMonitor();
      this.getEquipNodeStatistics();
      this.getAlarms();
      this.getExceptionATj();

      setTimeout(() => {
        this.scrollTable();
      }, 500);
    },

    // 幻灯片切换
    carouselChange(idx) {
      this.activeIdx = idx;
    },

    mouseEnter(idx) {
      this.activeIdx = idx;
      this.$refs.carousel.setActiveItem(idx);
    },

    // 创建图表
    createChart() {
      if (this.exceptionData.length == 0) {
        if (!utils.isNull(this.echartPanel)) {
          this.echartPanel.clear();
        }
        return;
      }
      let legendData = [];
      let xAxisData = [];
      let seriesData = [];
      for (let i of this.exceptionData) {
        legendData.push(i.name);
        xAxisData.push(i.name);
        seriesData.push(i.count);
      }
      // 基于准备好的dom，初始化echarts实例
      this.echartPanel = echarts.init(document.getElementById("echart-panel0"));
      // 指定图表的配置项和数据
      let option = {
        color: function(params) {
          let colorList = [
            "#249CF9",
            "#EB6F49",
            "#FDB628",
            "#00E4EC",
            "#69FD28",
            "#C490BF",
            "#FFF100",
            "#486A00",
            "#F6B37F",
            "#7ECEF4",
            "#22AC38",
            "#7E6B5A"
          ];
          return colorList[params.dataIndex % colorList.length];
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        grid: {
          left: "0",
          right: "2%",
          top: "10%",
          bottom: "2%",
          containLabel: true
        },
        legend: {
          data: legendData
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: "#5492ED"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: "#5492ED"
            }
          },
          splitLine: {
            // 轴上的分割线
            show: true,
            lineStyle: {
              // 设置分割线单独的样式
              color: "#5492ED"
            }
          }
        },
        series: [
          {
            type: "custom",
            barWidth: "30",
            data: seriesData,
            renderItem: (params, api) => {
              return this.getRenderItem(params, api);
            },
            itemStyle: {
              normal: {
                color: "#01A4FD"
              }
            }
          }
        ]
      };

      this.echartPanel.setOption(option);
    },
    getRenderItem(params, api) {
      // 柱子索引值
      const { seriesIndex } = params;
      // 基础坐标
      const basicsCoord = api.coord([api.value(seriesIndex), api.value(1)]);
      // 顶部基础y轴
      const topBasicsYAxis = basicsCoord[1];
      // 基础x轴
      const basicsXAxis = basicsCoord[0];
      // 底部基础y轴
      const bottomYAxis = api.coord([api.value(seriesIndex), 0])[1];
      this.setThreeShapes();

      // 计算文本位置
      const textX = basicsXAxis; // 文本位于柱子中心
      const textY = topBasicsYAxis - 10; // 文本位于柱子上方

      return {
        type: "group",
        children: [
          {
            type: "leftShape",
            shape: {
              topBasicsYAxis,
              basicsXAxis,
              bottomYAxis
            },
            style: {
              ...api.style(),
              fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#02d4eb" },
                { offset: 1, color: "#019fff" }
              ])
            }
          },
          {
            type: "rightShape",
            shape: {
              topBasicsYAxis,
              basicsXAxis,
              bottomYAxis
            },
            style: {
              ...api.style(),
              fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#52eeff" },
                { offset: 1, color: "#37b3ff" }
              ])
            }
          },
          {
            type: "topShape",
            shape: {
              topBasicsYAxis,
              basicsXAxis,
              bottomYAxis
            },
            style: {
              ...api.style(),
              fill: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
                { offset: 0, color: "#34e9fd" },
                { offset: 1, color: "#19e5fc" }
              ])
            }
          },
          // 添加文本
          {
            type: "text",
            style: {
              text: api.value(1).toFixed(0),
              textAlign: "center",
              textBaseline: "middle",
              fill: "#fff",
              font: "12px sans-serif"
            },
            position: [textX, textY]
          }
        ]
      };
    },

    setThreeShapes() {
      // 侧面宽度
      const WIDTH = (12 / 1920) * document.body.clientWidth;
      // 斜角高度
      const OBLIQUE_ANGLE_HEIGHT = (5 / 1920) * document.body.clientWidth;
      // 绘制柱状体三个面的图形并注册
      const leftShape = echarts.graphic.extendShape({
        buildPath(ctx, shape) {
          const { topBasicsYAxis, bottomYAxis, basicsXAxis } = shape;
          const p1 = [
            basicsXAxis - (WIDTH * 3) / 4,
            topBasicsYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 左上角坐标
          const p2 = [
            basicsXAxis + WIDTH / 4,
            topBasicsYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 右上角坐标
          const p3 = [
            basicsXAxis + WIDTH / 4,
            bottomYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 右下角坐标
          const p4 = [
            basicsXAxis - (WIDTH * 3) / 4,
            bottomYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 左下角坐标
          ctx.moveTo(p1[0], p1[1]);
          ctx.lineTo(p2[0], p2[1]);
          ctx.lineTo(p3[0], p3[1]);
          ctx.lineTo(p4[0], p4[1]);
        }
      });
      const rightShape = echarts.graphic.extendShape({
        buildPath(ctx, shape) {
          const { topBasicsYAxis, bottomYAxis, basicsXAxis } = shape;
          const p1 = [
            basicsXAxis + WIDTH / 4,
            topBasicsYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 左上角坐标
          const p2 = [basicsXAxis + (WIDTH * 3) / 4, topBasicsYAxis]; // 右上角坐标
          const p3 = [basicsXAxis + (WIDTH * 3) / 4, bottomYAxis]; // 右下角坐标
          const p4 = [
            basicsXAxis + WIDTH / 4,
            bottomYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 左下角坐标
          ctx.moveTo(p1[0], p1[1]);
          ctx.lineTo(p2[0], p2[1]);
          ctx.lineTo(p3[0], p3[1]);
          ctx.lineTo(p4[0], p4[1]);
        }
      });
      const topShape = echarts.graphic.extendShape({
        buildPath(ctx, shape) {
          const { topBasicsYAxis, basicsXAxis } = shape;
          const p1 = [basicsXAxis - WIDTH / 4, topBasicsYAxis]; // 左上角坐标
          const p2 = [basicsXAxis + (WIDTH * 3) / 4, topBasicsYAxis]; // 右上角坐标
          const p3 = [
            basicsXAxis + WIDTH / 4,
            topBasicsYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 右下角坐标
          const p4 = [
            basicsXAxis - (WIDTH * 3) / 4,
            topBasicsYAxis + OBLIQUE_ANGLE_HEIGHT
          ]; // 左下角坐标
          ctx.moveTo(p1[0], p1[1]);
          ctx.lineTo(p2[0], p2[1]);
          ctx.lineTo(p3[0], p3[1]);
          ctx.lineTo(p4[0], p4[1]);
        }
      });
      echarts.graphic.registerShape("leftShape", leftShape);
      echarts.graphic.registerShape("rightShape", rightShape);
      echarts.graphic.registerShape("topShape", topShape);
    },

    // 设置定时改变table
    scrollTable() {
      if (utils.isNull(this.tableTimer)) {
        let _this = this;
        this.tableTimer = setInterval(() => {
          let abnormalAlarms = _this.alarmsData.abnormalAlarms;
          let equipRunParams = _this.monitorData.equipRunParams;
          // 报警提示 滚动
          if (abnormalAlarms && abnormalAlarms.length > 0) {
            let alarmsTable = _this.$refs.alarmsTable.$refs.bodyWrapper;
            let scrollTop = alarmsTable.scrollTop;
            scrollTop += 1;
            // 判断滚到到最后 重置0
            let clientHeight = alarmsTable.clientHeight;
            let scrollHeight = alarmsTable.scrollHeight;
            if (
              scrollHeight > clientHeight &&
              scrollTop + clientHeight >= scrollHeight
            ) {
              scrollTop = 0;
            }
            alarmsTable.scrollTop = scrollTop;
          }

          // 设备运行参数 滚动
          // if (equipRunParams && equipRunParams.length > 0) {
          //   let configTable = _this.$refs.configTable.$refs.bodyWrapper;
          //   let scrollTop = configTable.scrollTop;
          //   scrollTop += 1;
          //   // 判断滚到到最后 重置0
          //   let clientHeight = configTable.clientHeight;
          //   let scrollHeight = configTable.scrollHeight;
          //   if (
          //     scrollHeight > clientHeight &&
          //     scrollTop + clientHeight >= scrollHeight
          //   ) {
          //     scrollTop = 0;
          //   }
          //   configTable.scrollTop = scrollTop;
          // }
        }, 50);
      }
    },
    startScrolling() {
      let _this = this;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.scrollPosition = 0;
        this.intervalId = null;
      }
      _this.intervalId = setInterval(() => {
        _this.scrollPosition += 1; // 每次滚动 10px
        if (
          _this.scrollPosition >=
          _this.itemHeight * _this.monitorData.equipRunParams.length
        ) {
          _this.scrollPosition = 0; // 重置位置
        }
        _this.$refs.configTable.scrollTop = _this.scrollPosition;
      }, 50); // 每 50ms 滚动一次
    },
    // 设置定时 改变时间
    changeTime() {
      if (utils.isNull(this.timer)) {
        let _this = this;
        this.timer = setInterval(() => {
          _this.timeStr = utils.getTotime() + `(星期${utils.getWeek()})`;
        }, 1000);
      }
    },
    getPieChart() {
      getAction("/iot/abnormalAlarmLevelStatistics?equipType=1").then(res => {
        // 报警统计
        let tmpPieChartData = [];
        res.data.list.forEach(item => {
          if (item.alarmLevel != null) {
            tmpPieChartData.push({
              value: parseInt(item.count),
              name: ["", "一级", "二级", "三级"][item.alarmLevel]
            });
          }
        });
        this.pieChartData = JSON.parse(JSON.stringify(tmpPieChartData));
        setTimeout(() => {
          this.setPieChartConfig();
        }, 2000);
      });
    },
    setPieChartConfig() {
      if (this.pieChartData.length == 0) {
        if (!utils.isNull(pieChart)) {
          pieChart.clear();
        }
        return;
      }
      pieChart = echarts.init(document.getElementById("pie-chart0"));
      let series = this.getPie3D(this.pieChartData, 0.6); // 可做为调整内环大小 0为实心圆饼图，大于0 小于1 为圆环
      series.push({
        name: "pie2d",
        type: "pie",
        label: {
          opacity: 1,
          fontSize: (16 / 1920) * document.body.clientWidth,
          textStyle: {
            fontSize: (16 / 1920) * document.body.clientWidth,
            color: "#fff"
          }
        },
        startAngle: 2, //起始角度，支持范围[0, 360]。
        clockwise: false, //饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ["50%", "60%"],
        radius: ["50%", "60%"],
        center: ["62%", "50%"],
        data: this.pieChartData,
        itemStyle: {
          opacity: 0
        },
        labelLine: {
          show: false
        },
        label: {
          show: false,
          position: "center"
        }
      });
      let legendData = this.pieChartData.map(item => item.name);
      // 准备待返回的配置项，把准备好的 legendData、series 传入。
      let option = {
        legend: {
          top: "center",
          left: "60%",
          orient: "vertical",
          itemWidth: (8 / 1920) * document.body.clientWidth,
          itemHeight: (8 / 1920) * document.body.clientWidth,
          itemGap: (25 / 1920) * document.body.clientWidth,
          itemRadius: (20 / 1920) * document.body.clientWidth,
          show: true,
          tooltip: {
            show: false
          },
          data: legendData,
          textStyle: {
            color: "#fff",
            fontSize: (16 / 1920) * document.body.clientWidth,
            rich: {
              name: {
                fontSize: (16 / 1920) * document.body.clientWidth,
                padding: [0, 0, 0, (12 / 1920) * document.body.clientWidth]
              },
              value: {
                fontSize: (16 / 1920) * document.body.clientWidth,
                padding: [0, 0, 0, (30 / 1920) * document.body.clientWidth],
                color: "#8BE1FA"
              }
            }
          },
          formatter: name => {
            let res = this.pieChartData.filter(v => v.name === name);
            res = res[0] || {};
            return `{name|${name}}{value|${res.value}}`;
          }
        },
        animation: true,
        tooltip: {
          show: true,
          textStyle: {
            fontSize: (14 / 1920) * document.body.clientWidth
          },
          formatter: params => {
            const { seriesName } = params;
            let res = this.pieChartData.filter(v => v.name === seriesName);
            res = res[0] || {};
            return `${seriesName}报警<br/>${
              params.marker
            } 报警数量<b style="margin-left: ${(15 / 1920) *
              document.body.clientWidth}px;">${res.value}</b>`;
          }
        },
        label: {
          show: true,
          position: "outside",
          formatter: function(optionsData) {
            return (
              "{name|" +
              optionsData.name +
              "}" +
              " {value|" +
              optionsData.percent.toFixed(0) +
              "%}"
            );
          },
          rich: {
            name: {
              fontSize: (14 / 1920) * document.body.clientWidth,
              color: "#ffffff"
            },
            value: {
              fontSize: (14 / 1920) * document.body.clientWidth,
              color: "#ffffff"
            }
          },
          textStyle: {
            color: "#fff",
            fontSize: (14 / 1920) * document.body.clientWidth
          }
        },
        xAxis3D: {
          min: -1,
          max: 1
        },
        yAxis3D: {
          min: -1,
          max: 1
        },
        zAxis3D: {
          min: -1,
          max: 1
        },
        grid3D: {
          show: false,
          boxHeight: 2,
          width: "60%",
          viewControl: {
            distance: 250,
            alpha: 30,
            beta: 15,
            autoRotate: false // 自动旋转
          }
        },
        series: series
      };
      console.log(option, " option11111");
      pieChart.setOption(option);
      window.addEventListener("resize", e => {
        setTimeout(() => {
          if (!utils.isNull(pieChart)) {
            pieChart.resize();
          }
        }, 400);
      });
    },
    // 生成模拟 3D 饼图的配置项
    getPie3D(pieData, internalDiameterRatio) {
      const colors = ["#00c6ff", "#a1dffc", "#007eff"];
      const series = [];
      const legendData = [];
      let sumValue = 0;
      let startValue = 0;
      let endValue = 0;
      let k =
        typeof internalDiameterRatio !== "undefined"
          ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio)
          : 1 / 3;

      // 为每一个饼图数据，生成一个 series-surface 配置
      console.log(pieData, "pieData11111");
      pieData.forEach((item, index) => {
        sumValue += item.value;

        const seriesItem = {
          name: typeof item.name === "undefined" ? `series${index}` : item.name,
          type: "surface",
          parametric: true,
          wireframe: {
            show: false
          },
          pieData: item,
          itemStyle: {
            color: colors[index], // 自定义颜色
            opacity: "1"
          },
          pieStatus: {
            selected: false,
            hovered: false,
            k: k
          }
        };

        if (typeof item.itemStyle != "undefined") {
          const itemStyle = {};

          typeof item.itemStyle.color != "undefined"
            ? (itemStyle.color = item.itemStyle.color)
            : null;
          typeof item.itemStyle.opacity != "undefined"
            ? (itemStyle.opacity = item.itemStyle.opacity)
            : null;

          seriesItem.itemStyle = itemStyle;
        }
        series.push(seriesItem);
      });

      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      series.forEach((item, index) => {
        endValue = startValue + item.pieData.value;
        item.pieData.startRatio = startValue / sumValue;
        item.pieData.endRatio = endValue / sumValue;
        item.parametricEquation = this.getParametricEquation(
          item.pieData.startRatio,
          item.pieData.endRatio,
          false,
          false,
          k,
          // 调整扇形高度
          index === 0 ? 10 : 10,
          index
          // item.pieData.value
        );

        startValue = endValue;

        legendData.push(item.name);
      });
      return series;
    },
    getParametricEquation(
      startRatio,
      endRatio,
      isSelected,
      isHovered,
      k,
      height,
      i
    ) {
      // 计算
      let midRatio = (startRatio + endRatio) / 2;

      let startRadian = startRatio * Math.PI * 2;
      let endRadian = endRatio * Math.PI * 2;
      let midRadian = midRatio * Math.PI * 2;

      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }

      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== "undefined" ? k : 1 / 3;

      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      let offsetZ = i == 1 ? 2 : 0;
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      let hoverRate = isHovered ? 1.05 : 1;

      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },

        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },

        x: function(u, v) {
          if (u < startRadian) {
            return (
              offsetX +
              Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          if (u > endRadian) {
            return (
              offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },

        y: function(u, v) {
          if (u < startRadian) {
            return (
              offsetY +
              Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          if (u > endRadian) {
            return (
              offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            );
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },

        z: function(u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u);
          }
          return Math.sin(v) > 0 ? 1 * height : -1;
        }
      };
    },

    // 获取数据
    getMonitor() {
      this.monitorData = "";
      this.deviceList = "";

      getAction(`/iot/integratedOperationMonitoring/v2?equipType=1`).then(
        res => {
          if (res.data.code == 200) {
            this.monitorData = res.data.data;
            this.startScrolling();
          } else {
            this.$message.error(res.data.msg);
          }
          this.showDataState = true;
        }
      );
    },
    getEquipNodeStatistics() {
      console.log(this.userInfo, "this.useerInfo");
      this.deviceData = "";
      getAction(
        `/iot/equip-node/equipNodeStatisticsScreens?projectId=${this.userInfo.projectId}&equipType=1`
      ).then(res => {
        if (res.data.code == 200) {
          console.log(res, "res");

          this.deviceData = {
            countEquipNum: this.chengeNumDanwei(res.data.data.countEquipNum),
            countCameraNum: this.chengeNumDanwei(res.data.data.countCameraNum),
            cameraOnlineNum: this.chengeNumDanwei(
              res.data.data.cameraOnlineNum
            ),
            cameraOfflineNum: this.chengeNumDanwei(
              res.data.data.cameraOfflineNum
            ),
            countOnlineNum: this.chengeNumDanwei(res.data.data.countOnlineNum),
            countOfflineNum: this.chengeNumDanwei(
              res.data.data.countOfflineNum
            ),
            countAlarmNum: this.chengeNumDanwei(res.data.data.countAlarmNum),
            waitForAlarmNum: this.chengeNumDanwei(res.data.data.waitForAlarmNum)
          };
          console.log(this.deviceData, "11111");
        } else {
          this.$message.error(res.data.msg);
        }
        this.showDataState = true;
      });
    },
    chengeNumDanwei(val) {
      let num = parseInt(val);
      if (val > 10000) {
        num = parseInt(num / 1000);
        num = num / 10 + "万";
      }
      return num;
    },
    // 获取报警提示
    getAlarms() {
      this.alarmsData = "";
      getAction(`/iot/integratedAbnormalAlarms?equipType=1`).then(res => {
        if (res.data.code == 200) {
          this.alarmsData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取异常统计
    getExceptionATj() {
      this.exceptionData = "";
      getAction(`/iot/integratedATj?equipType=1`).then(res => {
        if (res.data.code == 200) {
          this.exceptionData = res.data.data;

          setTimeout(() => {
            this.createChart();
          }, 500);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    showCameraDlg(item0) {
      let item = {
        state: item0,
        type: 1
      };
      this.dlgCameraQuery = item;
      this.$refs.cameraDlg.dlgState = true;
    },
    // 跳转
    pageTo(idx) {
      if (idx < 2) {
        this.$router.push({ path: `/equipSafeMan/sensorEquip` });
      } else if (idx == 2) {
        this.$router.push({
          path: `/equipSafeMan/sensorEquip`,
          query: { state: "2" }
        });
      } else if (idx == 3) {
        this.$router.push({
          path: `/equipSafeMan/abnormalAlarmMan`,
          query: { status: "1" }
        });
        this.$router.push({
          path: `/equipSafeMan/abnormalAlarmMan`,
          query: { status: "1" }
        });
      } else if (idx == 4) {
        this.$router.push({
          path: `/equipSafeMan/abnormalAlarmMan`,
          query: { status: "0" }
        });
      }
    },

    // 查看详情
    viewItem(id) {
      this.$router.push({ path: `/equipSafeMan/monitorDesc/${id}` });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.no-scrollbar {
  scrollbar-width: none; //火狐隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    overflow: hidden;
  }
}
.app-container {
  background: url("/static/image/equip/bg.png") no-repeat center;
  background-size: cover;
  padding: 0 20px;
  z-index: 20;
  .title-container {
    position: relative;
    height: 88px;
    font-size: 36px;
    // font-weight: bold;
    line-height: 80px;
    color: #fff;
    text-align: center;
    background: url("/static/image/equip/top-bj@2x.png") no-repeat center;
    background-size: 100% 100%;
    .runDays {
      position: absolute;
      left: 0;
      width: 151px;
      padding-top: 6px;
      margin-bottom: 0;
      font-size: 18px;
      text-align: center;
    }
    .time {
      position: absolute;
      right: 0;
      width: 275px;
      padding-top: 6px;
      font-size: 18px;
    }
  }
  .content-container {
    position: relative;
    height: calc(100% - 88px);
    overflow: hidden;
    .nums {
      display: flex;
      width: 75%;
      height: 100px;
      margin: 0 auto;
      margin-top: 10px;

      .lixian {
        width: 30%;
        height: 58px;
        text-align: center;
        cursor: pointer;
        background: url("/static/image/equip/shebei-small-bg.png") no-repeat
          center;

        &:hover {
          opacity: 0.7;
        }

        .name {
          margin-left: 20px;
          font-size: 14px;
          color: #d3e2fd;
        }

        .num-unit {
          margin-left: -10px;

          .num {
            margin-right: 5px;
            font-size: 20px;
            font-style: italic;
            font-weight: bolder;
            color: #fff;
          }

          .unit {
            font-size: 16px;
            color: #d3e2fd;
          }
        }
      }

      .zaixian {
        width: 40%;
        height: 67px;
        text-align: center;
        cursor: pointer;
        background: url("/static/image/equip/shebei-medium-bg.png") no-repeat
          center;

        &:hover {
          opacity: 0.7;
        }

        .name {
          margin-top: 10px;
          font-size: 16px;
          color: #d3e2fd;
        }

        .num-unit {
          margin-left: -10px;

          .num {
            margin-right: 5px;
            font-size: 22px;
            font-style: italic;
            font-weight: bolder;
            color: #fff;
          }

          .unit {
            font-size: 18px;
            color: #d3e2fd;
          }
        }
      }

      .zongshu {
        width: 50%;
        height: 91px;
        text-align: center;
        cursor: pointer;
        background: url("/static/image/equip/shebei-big-bg.png") no-repeat
          center;

        &:hover {
          opacity: 0.7;
        }

        .name {
          margin-top: 20px;
          font-size: 20px;
          color: #d3e2fd;
        }

        .num-unit {
          margin-left: -30px;

          .num {
            margin-right: 5px;
            font-size: 28px;
            font-style: italic;
            font-weight: bolder;
            color: #fff;
          }

          .unit {
            font-size: 24px;
            color: #d3e2fd;
          }
        }
      }

      .yichang {
        width: 40%;
        height: 67px;
        text-align: center;
        cursor: pointer;
        background: url("/static/image/equip/shebei-medium-bg.png") no-repeat
          center;

        &:hover {
          opacity: 0.7;
        }

        .name {
          margin-top: 10px;
          margin-left: -10px;
          font-size: 18px;
          color: #d3e2fd;
        }

        .num-unit {
          margin-left: -30px;

          .num {
            margin-right: 5px;
            font-size: 22px;
            font-style: italic;
            font-weight: bolder;
            color: #fff;
          }

          .unit {
            font-size: 18px;
            color: #d3e2fd;
          }
        }
      }

      .daichuli {
        width: 30%;
        height: 58px;
        text-align: center;
        cursor: pointer;
        background: url("/static/image/equip/shebei-small-bg.png") no-repeat
          center;

        &:hover {
          opacity: 0.7;
        }

        .name {
          margin-left: 10px;
          font-size: 16px;
          color: #d3e2fd;
        }

        .num-unit {
          margin-left: -10px;

          .num {
            margin-right: 5px;
            font-size: 20px;
            font-style: italic;
            font-weight: bolder;
            color: #fff;
          }

          .unit {
            font-size: 16px;
            color: #d3e2fd;
          }
        }
      }
    }
    .left-container {
      float: left;
      width: calc(70% - 10px);
      height: 100%;
      .top-container {
        position: relative;
        height: 425px;
        .left-container {
          float: left;
          width: 492px;
          height: 100%;
          .title {
            position: absolute;
            top: -35px;
            width: 478px;
            height: 35px;
            text-align: center;
            background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png")
              no-repeat center;

            span {
              margin-left: -150px;
              font-size: 20px;
            }
          }
          .state-container {
            width: 100%;
            height: calc(100% - 25px);
            margin-top: 20px;
            overflow-y: auto;
            scrollbar-width: none;
            font-weight: bolder;

            .state-item {
              position: relative;
              float: left;
              width: 100%;
              height: 70px;
              padding: 6px 0 0 12px;
              margin-bottom: 10px;
              text-align: center;
              cursor: pointer;
              background: url("/static/image/equip/shebeiyunxingzhuangtai-item-blue.png")
                no-repeat -10px 0;
              border: 1px solid transparent;
              // &.error {
              //   background: rgba(254, 85, 85, 0.1);
              //   border: 1px solid #fe5555;
              // }
              &.active {
                z-index: 999;
                background: url("/static/image/equip/shebeiyunxingzhuangtai-item-yellow.png")
                  no-repeat -10px 0;
                border-top: 1px solid #0491ca;
                border-right: 4px solid #09152b !important;
                border-bottom: 1px solid #0491ca;
                border-left: 1px solid #0491ca;
                border-bottom-left-radius: 10px;
                border-top-left-radius: 10px;
                .border-radius-bottom::after {
                  position: absolute;
                  right: -3px; /* 向外扩展 */
                  bottom: -10px;
                  z-index: 99999;
                  width: 10px;
                  height: 10px;
                  background-color: #09152b;
                  border-top: none;
                  border-top: 1px solid #0491ca;
                  border-right: 1px solid #0491ca;
                  border-top-right-radius: 10px; /* 向外的圆角 */
                  content: "";
                }

                .zhegai-border-bottom::after {
                  position: absolute;
                  right: -15px; /* 向外扩展 */
                  bottom: -10px;
                  z-index: 99999;
                  width: 20px;
                  height: 10px;
                  background-color: #09152b;
                  content: "";
                }

                &:first-child {
                  .fugai-border-top {
                    position: absolute;
                    top: -1px;
                    right: -10px; /* 向外扩展 */
                    z-index: 99999;
                    width: 20px;
                    height: 20px;
                    background-color: #09152b;
                    border-top: 1px solid #0491ca;
                  }
                }

                &:not(:first-child) {
                  .equip-state::after {
                    position: absolute;
                    top: -26px;
                    right: -3px; /* 向外扩展 */
                    z-index: 99999;
                    width: 20px;
                    height: 20px;
                    background-color: #09152b;
                    border-top: none;
                    border-right: 1px solid #0491ca;
                    border-bottom: 1px solid #0491ca;
                    border-bottom-right-radius: 10px; /* 向外的圆角 */
                    content: "";
                  }

                  .zhegai-border::after {
                    position: absolute;
                    top: -10px;
                    right: -10px; /* 向外扩展 */
                    z-index: 99999;
                    width: 20px;
                    height: 20px;
                    background-color: #09152b;
                    content: "";
                  }
                }
              }
              &:nth-child(2n + 2) {
                margin-right: 0;
              }
              .equip-info {
                width: 100%;
                position: relative;
                .equip-name {
                  position: absolute;
                  left: 60px;
                  top: 10px;
                  font-size: 16px;
                  color: #fff;
                }

                .equip-state {
                  display: flex;
                  margin-left: 50%;

                  .equip-state-quanbu {
                    margin-top: 10px;
                    color: #d3e2fd;

                    .count {
                      margin-top: 5px;
                      margin-left: -15px;
                      font-style: italic;
                      color: #fff;
                    }
                  }

                  .equip-state-zaixian {
                    margin-top: 10px;
                    margin-left: 50px;
                    color: #d3e2fd;

                    .count {
                      margin-top: 5px;
                      margin-left: -15px;
                      font-style: italic;
                      color: #fff;
                    }
                  }

                  .equip-state-lixian {
                    margin-top: 10px;
                    margin-left: 50px;
                    color: #d3e2fd;

                    .count {
                      margin-top: 5px;
                      margin-left: -15px;
                      font-style: italic;
                      color: #fff;
                    }
                  }
                }
              }
            }
            &::-webkit-scrollbar {
              width: 0 !important;
            }
          }
        }
        .right-container {
          position: absolute;
          left: 490px;
          float: right;
          width: calc(100% - 492px);
          height: calc(100% - 26px);
          margin-top: 20px;
          border: 1px solid #047baf;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
          .statistical-container {
            width: 100%;
            height: 100%;
            .bottom-container {
              height: 100%;
              // background: rgb(0 186 255 / 10%);
              // border: 1px solid #369aff;
              .equipRoomItems-name {
                width: 300px;
                height: 33px;
                background: url("/static/image/equip/equipRoomItems-bg.png")
                  no-repeat;

                .name {
                  height: 33px;
                  margin-bottom: 10px;
                  margin-left: 40px;
                  font-size: 18px;
                  font-style: italic;
                  font-weight: bolder;
                  line-height: 20px;
                  color: #fff;
                }
              }

              .el-carousel {
                height: 100%;

                /deep/ .el-carousel__container {
                  height: 375px;

                  .el-carousel__item {
                    padding: 10px;

                    div.detail {
                      width: 100%;
                      height: 75px;
                      padding: 10px 0 0;
                      margin-top: 10px;
                      background: url("/static/image/equip/bj-blue.png")
                        no-repeat center center;
                      background-size: 100% 100%;
                      // height: 126px;
                      // overflow-y: auto;
                      span {
                        float: left;
                        width: 20%;
                        margin-bottom: 10px;
                        font-size: 16px;
                        text-align: center;

                        div:first-child {
                          margin-bottom: 10px;
                          color: #ccd6ed;

                          &.error {
                            color: #fc010d;
                          }
                        }

                        div:last-child {
                          overflow: hidden;
                          font-weight: bolder;
                          color: #fff;
                          white-space: nowrap;
                        }

                        &.filter-gray {
                          div {
                            color: #999;
                          }
                        }
                      }

                      &.row2 {
                        span {
                          font-size: 14px;
                        }
                      }
                    }

                    .equipRoomItems-name-huanjing {
                      width: 167px;
                      height: 33px;
                      margin-top: 10px;
                      margin-left: -20px;
                      background: url("/static/image/equip/equipRoomItems-bg.png")
                        no-repeat;

                      .name {
                        height: 33px;
                        margin: 0 0 10px 40px;
                        font-size: 18px;
                        font-style: italic;
                        font-weight: bolder;
                        line-height: 20px;
                        color: #fff;
                      }
                    }

                    .equipRoomItems-name-24hours {
                      width: 167px;
                      height: 33px;
                      margin-top: 10px;
                      margin-left: -20px;
                      background: url("/static/image/equip/equipRoomItems-bg.png")
                        no-repeat;

                      .name {
                        height: 33px;
                        margin: 0 0 10px 40px;
                        font-size: 18px;
                        font-style: italic;
                        font-weight: bolder;
                        line-height: 20px;
                        color: #fff;
                      }
                    }

                    .blue {
                      background: url("/static/image/equip/bj-blue.png")
                        no-repeat center center;
                      background: url("/static/image/equip/bj-blue.png")
                        no-repeat center center;
                      background-size: 100% 100%;
                    }

                    .red {
                      background: url("/static/image/equip/bj-red.png")
                        no-repeat center center;
                      background: url("/static/image/equip/bj-red.png")
                        no-repeat center center;
                      background-size: 100% 100%;
                    }

                    .fred {
                      width: 100%;
                      height: 75px;
                      padding: 10px 0 0;
                      margin-top: 10px;
                      font-size: 18px;
                      color: #f00;
                      .fred-name {
                        margin-bottom: 10px;
                        margin-left: 40px;
                        font-size: 16px;
                        color: #edcccc;
                      }

                      .fred-content {
                        margin-left: 40px;
                        font-weight: bolder;

                        span {
                          margin-left: 20px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .bottom-container {
        position: relative;
        height: calc(100% - 145px);
        .bottom-left {
          float: left;
          width: 492px;
          height: calc(100% - 415px);

          .title {
            position: absolute;
            width: 478px;
            height: 35px;
            background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png")
              no-repeat center;

            span {
              margin-left: 105px;
              font-size: 20px;
            }
          }

          .pie-container {
            height: calc(100% - 20px);
            margin-top: 30px;
          }
        }

        .bottom-center {
          float: right;
          width: calc(100% - 492px);
          // height: 26%;
          height: calc(100% - 415px);

          .title {
            position: absolute;
            width: 478px;
            height: 35px;
            background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png")
              no-repeat center;

            span {
              margin-left: 105px;
              font-size: 20px;
            }
          }

          .echart-container {
            height: calc(100% - 20px);
            margin-top: 30px;
          }
        }
      }
    }
    .right-container0 {
      position: relative;
      float: right;
      width: 30%;
      height: 100%;

      .top-container {
        // height: 630px;
        // height: 69%;
        height: 425px;
        margin-bottom: 10px;

        .top-title {
          position: absolute;
          top: -35px;
          left: 75px;
          width: 478px;
          height: 35px;
          font-size: 20px;
          color: #fff;
          background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png")
            no-repeat center;

          div {
            margin: 0 0 20px 105px;
            font-size: 20px;
          }
        }

        .state-container {
          width: 100%;
          height: calc(100% - 30px);
          margin-top: 20px;
          overflow-y: auto;
          scrollbar-width: none;

          .state-item {
            display: flex;
            height: 116px;
            padding: 20px 40px;
            margin-bottom: 10px;
            cursor: pointer;
            background: url("/static/image/equip/shebeiyunxingcanshu-item-bg.png")
              no-repeat;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover; /* 或者使用 'contain' */
            // background: rgb(0 186 255 / 10%);
            // border: 1px solid #369aff;
            .state-item-title {
              width: 30%;
              margin-top: 10px;
            }

            .state-item-name {
              margin-bottom: 10px;
              font-size: 16px;
              color: #c8d7e8;
            }

            .state-item-equipRoomName {
              font-size: 18px;
              font-weight: bolder;
              color: #fff;
            }

            .state-item-bg {
              width: 155px;
              height: 100%;
              text-align: center;
              background: url("/static/image/equip/yibiaopan-bg.png") no-repeat;

              .state-bg-item {
                margin-top: 35px;
                font-size: 16px;
                font-weight: bolder;
                color: #fff;
              }
            }
          }
        }
      }

      .bottom-container {
        position: relative;
        // height: calc(100% - 635px);
        // height: 30%;
        // height: 26%;
        height: calc(100% - 590px);

        .title {
          position: absolute;
          top: -50px;
          width: 478px;
          height: 35px;
          background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png")
            no-repeat center;

          span {
            margin-left: 105px;
            font-size: 20px;
          }
        }
      }

      .table-container2 {
        height: 100%;
        margin-top: 35px;

        /deep/.el-table__header {
          background-image: url("/static/image/equip/table-bg.png");
          background-repeat: no-repeat;
          background-size: cover;
        }

        /deep/.el-table__row {
          background-image: url("/static/image/equip/table-item-bg.png");

          // box-shadow: 0 -3px 10px 1px #2a6394;
          td {
            border-collapse: separate;
            border-top: none;
            border-right: none;
            border-bottom: none;
            border-left: none; /* 内阴影 */
          }
        }
      }
    }
  }

  .title {
    position: relative;
    color: #ffffff;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
  }

  /deep/ .el-table::before {
    height: 0px;
  }

  /deep/ .el-table {
    background: transparent;
    .el-table__body {
      tr:hover > td {
        color: #022d53;
        background: #08142a;
        background-image: url("/static/image/equip/table-item-hoverbg.png") !important;
        background-image: url("/static/image/equip/table-item-hoverbg.png") !important;
      }
    }
    .el-table__header-wrapper {
      tr {
        background-color: transparent;
        th {
          color: #ffffff;
          background-color: rgba(0, 186, 255, 0.1);
          border: none;
          &.gutter {
            background: transparent;
          }
        }
      }
    }
    .el-table__body-wrapper {
      scrollbar-width: none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      tbody {
        tr {
          background: transparent;
          td {
            border: 1px solid #022d53;
            color: #a8e6f3;
          }
        }
      }
    }
  }
}
</style>
